"use strict";
/**
 * @module
 * @description
 * This module provides a set of common Pipes.
 */
var async_pipe_1 = require("./async_pipe");
/**
 * A collection of Angular core pipes that are likely to be used in each and every
 * application.
 *
 * This collection can be used to quickly enumerate all the built-in pipes in the `pipes`
 * property of the `@Component` decorator.
 *
 * @experimental Contains i18n pipes which are experimental
 */
exports.COMMON_PIPES = [
    async_pipe_1.AsyncPipe
];
//# sourceMappingURL=common_pipes.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-metadata/src/common/pipes/common_pipes.js
// module id = F9NK
// module chunks = 0